export default {
  title: 'Components/Dropdown',
  tags: ['autodocs'],
  argTypes: {
    size: {
      control: { type: 'select' },
      options: ['default', 'small'],
      description: 'Size of the select',
    },
    label: { control: 'text', description: 'Label for the select' },
    options: {
      control: 'object',
      description: 'Array of options (id and text)',
    },
    icon_mode: {
      control: 'boolean',
      description: 'Enable or disable icon mode',
    },
    selected: {
      control: 'text',
      description: 'Selected option (id or text)',
    },
    placeholder: {
      control: 'text',
      description: 'Placeholder text when no option is selected',
    },
    main_aria_label: {
      control: 'text',
      description: 'Aria Label text for the accessibility',
    },
    disabled: { control: 'boolean', description: 'Disable the select' },
    error: {
      control: { type: 'select' },
      options: ['normal', 'error'],
      description: 'Error state of the select',
    },
    error_message: { control: 'text', description: 'Error message to display' },
    helper_text: { control: 'text', description: 'Helper or footer text' },
    validation_id: { control: 'text', description: 'Validation ID' },
    custom_class: { control: 'text', description: 'Custom class for the select' },
    component_mode: {
      control: 'check',
      options: ['light-mode'],
      description: 'Mode of the select component',
    },
    button_id: { control: 'text', description: 'Button ID' },
    toggle_button_name: { control: 'text', description: 'Toggle button name' },
    option_select_button_name: { control: 'text', description: 'Option select button name' },
  },
  parameters: {
    docs: {
      description: {
        component: `
\`\`\`html
<dda-dropdown
  label="Select an option"
  placeholder="Please select..."
  main_aria_label="Please choose an option"
  selected="2"
  disabled="false"
  helper_text="Helper or footer text"
  error_message=""
  size="default"
  icon_mode="false"
  custom_class=""
  component_mode=""
  button_id="button"
  options='[{"id":1,"text":"Option 1"},{"id":2,"text":"Option 2"}]'
  toggle_button_name="toggle_button"
  option_select_button_name="option_button"
></dda-dropdown>
\`\`\`
        `,
      },
    },
  },
};

const Template = (args) => {
  const optionsAttribute = args.options ? `options='${JSON.stringify(args.options)}'` : '';
  const otherAttributes = Object.entries(args)
    .filter(([key]) => key !== 'options')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `
    <dda-dropdown ${optionsAttribute} ${otherAttributes}></dda-dropdown>
    <script>
      document.querySelector('dda-dropdown').addEventListener('selectChanged', e => {
        console.log('Selected:', e.detail);
      });
    </script>
  `;
};

const defaultOptions = [
  { id: '1', text: 'Option 1' },
  { id: '2', text: 'Option 2' },
  { id: '3', text: 'Option 3' },
  { id: '4', text: 'Option 4' },
  { id: '5', text: 'Option 5' },
];

export const Default = Template.bind({});
Default.args = {
  label: 'Select an option',
  placeholder: 'Please select...',
  main_aria_label: 'Please choose an option',
  options: defaultOptions,
  selected: '0',
  disabled: false,
  helper_text: 'Helper or footer text',
  error_message: '',
  validation_id: 'validationId',
  size: 'default',
  icon_mode: "false",
  custom_class: '',
  component_mode: '',
  button_id: 'button',
  toggle_button_name: 'toggle_button',
  option_select_button_name: 'option_button',
  selectChanged:"",
};

export const Small = Template.bind({});
Small.args = {
  ...Default.args,
  size: 'small',
};

export const WithError = Template.bind({});
WithError.args = {
  ...Default.args,
  error: 'error',
  error_message: 'This is an error message',
};

export const Disabled = Template.bind({});
Disabled.args = {
  ...Default.args,
  disabled: true,
};
